<template>
  <div class="v-d-news">
    <img class="deco-img top-deco" src="@/assets/img/index/bg_blue_1.svg" />
    <img class="deco-img shed-deco" src="@/assets/img/index/deco_shed.png" />
    <div class="v-d-news__content g-content">
      <more-carousel display link="announcements" :carouselList="newsBoxList" rounded="40" title="最新消息" deco  :isHome="true" :pagination="false"/>
    </div>
  </div>
</template>
<script>
import {
  defineComponent, ref, shallowRef, watch,
} from 'vue';

import { useRoute } from 'vue-router';
import { v4 as uuid } from 'uuid';
import useRequest from '@/hooks/useRequest';
import { getViewArticlesAPI } from '@/api/articles';
import previewImg from '@/assets/img/global/img_preview.jpg';
import MoreCarousel from '@/components/Global/MoreCarousel.vue';
import NewsBox from '@/components/Home/NewsBox.vue';

// import mediaImg1 from '@/assets/img/index/img_1.png';
// import mediaImg2 from '@/assets/img/index/img_2.png';
// import mediaImg3 from '@/assets/img/index/img_3.png';
// import mediaImg4 from '@/assets/img/index/img_4.png';

export default defineComponent({
  name: 'Media',
  components: {
    MoreCarousel,
  },
  setup() {
    const route = useRoute();
    const newsBoxList = ref([]);

    const { response, request, isLoading } = useRequest(getViewArticlesAPI);

    request({
      page: 1,
      limit: 8,
      type: 'news',
      category: route.query.tab,
    });

    const getViewArticles = async (res) => {
      const {
        result: { data },
        status,
      } = res.value;

      if (status) {
        const baseUrl = process.env.VUE_APP_BASE_URL;

        newsBoxList.value = data.map((item) => {
          const coverImageSrc = item.cover_path ? `${baseUrl}${item.cover_path}` : previewImg;

          return {
            data: {
              title: item.title,
              desc: item.description,
              id: item.uuid,
              type: item.category?.name || '',
              published: item.published,
            },
            id: uuid(),
            renderContent: shallowRef(NewsBox),
            imgPath: coverImageSrc,
          };
        });
      }
    };

    watch(response, () => {
      getViewArticles(response);
    });

    const articleList = ref();
    const itemWidth = ref();

    return {
      newsBoxList,
      articleList,
      itemWidth,
      isLoading,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/share/home.scss';
@import '~@/styles/utils/_rwd.scss';

.v-d-news {
  background-color: $c-home-light-blue;

  position: relative;

  &__content.g-content {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}

.top-deco {
  width: 100%;
  @include position(bl, calc(100% - 1px), 0);
}

.shed-deco {

  @include position(tr, 100%, 0);
  z-index: 20;
  transform: translateY(-53%);
}

.title {
  @include flex(space-between, flex-start);

}

.title-see-more {
  margin-top: 5px;
}

.article-wrap {
  width: 100%;
  margin-top: 40px;
  overflow: hidden;
}

.article-list {
  @include flex(flex-start, flex-start);
  width: 400%;
  transition: 0.4s;

  &__item {
    width: 50%;
    // margin-right: 54px;
  }
}

.tablet-show {
  display: none;
}

.see-more-wrap {
  margin-top: 30px;
}

@media screen and (min-width: $mobile) {
}

@media screen and (min-width: $tablet) {
  .v-d-news {
    background-color: $c-home-light-blue;
    position: relative;

    &__content.g-content {
      padding-top: 50px;
      padding-bottom: 50px;
    }
  }

  .article-wrap {
    // overflow: auto;
  }

  .article-list {
    flex-wrap: nowrap;
    width: 100%;
    margin: 0 -10px;

    &__item {
      flex: none;
      margin: 0 10px;
    }
  }

  .title {
    @include flex(space-between);
  }

  .mobile-show {
    display: none;
  }

  .tablet-show {
    display: block;
  }
}

@media screen and (min-width: $sm-pc) {
  // .v-d-news {
  //   &__content.g-content {
  //     padding: 160px 0 200px;
  //   }
  // }
}
@media screen and (min-width: $pc) {
  .v-d-news {
    &__content.g-content {
      padding: 160px 0 150px;
    }
  }

  .article-list {
    margin: 0 -35px;

    &__item {
      margin: 0 35px;
    }
  }
}
@media screen and (min-width: $lg-pc) {
}
</style>
